import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "regenerator-runtime/runtime";

import "@swa-ui/core/assets/styles/reset.scss";

import { App } from "./components/App";
import "./configure/configureBootstrap";
import "./configure/configureI18n";
import "./configure/configureLogger";
import "./configure/configureTheme";
import "./configure/configureYup";

const rootElement = createRoot(document.getElementById("root"));

rootElement.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
